import React, { useState } from "react";
import { Grid2 } from "@mui/material";
import { useSetState } from "Utils/Helpers/Hooks";
import Inputer from "Utils/Helpers/Inputer";
import MButton from "Utils/Helpers/MButton";
import Icon from "Utils/Assets/Images/Logo.png";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { auth_users } from "http/components/User";
import { useDispatch } from "react-redux";
import { HandleLogin } from "Utils/Helpers/HandleLogin";
import { useNavigate } from "react-router-dom";

export default function LoginBox() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const [controls, setControls] = useSetState({
    username: {
      display: true,
      label: "Username",
      type: "text",
      multiLine: false,
      placeholder: "Username",
      value: "",
      validation: false,
    },
    password: {
      display: true,
      label: "Password",
      type: "password",
      multiLine: false,
      placeholder: "Password",
      value: "",
      validation: false,
    },
  });

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value, validation } });
  };

  const onSubmit = async () => {
    dispatch(HandleLoading(true));
    const { username, password } = controls;
    if (username.validation && password.validation) {
      const response = await auth_users({
        username: username.value,
        password: password.value,
      });
      dispatch(HandleLoading(false));
      if (response.status) {
        setError("");
        dispatch(HandleLogin(navigate, response.data));
      } else {
        setError("The username or password is incorrect");
      }
    } else {
      dispatch(HandleLoading(true));
      setError("Enter your username and password correctly");
    }
  };

  return (
    <div className="auth-items">
        <Grid2 container spacing={2} className="auth-items-content">
          <img className="auth-icon" src={Icon} alt="tamima-icon" />
          <p className="auth-title">Welcome to Tamima admin panel</p>
          <form onSubmit={onSubmit} className="w-100">
            {Object.keys(controls).map((key, index) => {
              return (
                <Grid2 size={{ xs: 12 }} key={key + index}>
                  {["text", "password"].includes(controls[key].type) && (
                    <Inputer
                      id={key}
                      setValue={setValue.bind(this)}
                      value={controls[key].value}
                      label={controls[key].label}
                      placeholder={controls[key].placeholder}
                      type={controls[key].type}
                      multiLine={controls[key].multiLine}
                    />
                  )}
                </Grid2>
              );
            })}
          </form>
          {error !== "" && <p className="auth-error">{error}</p>}
          <Grid2 size={{ xs: 12 }}>
            <MButton
              label={"Enter"}
              color="primary"
              onClick={onSubmit}
              className="w-100"
            />
          </Grid2>
        </Grid2>
      </div>
  );
}